import { MainFilterType, OtherFilterType } from "./filter-type";

export const initialMainFilters: Record<MainFilterType, boolean> = {
  [MainFilterType.Call]: false,
  [MainFilterType.Noanswer]: false,
  [MainFilterType.Email]: false,
  [MainFilterType.SMS]: false,
  [MainFilterType.Comment]: false,
  [MainFilterType.Interest]: false
};

export const initialOtherFilters: Record<OtherFilterType, boolean> = {
  [OtherFilterType.GDPR]: false,
  [OtherFilterType.QualityUpdate]: false,
  [OtherFilterType.Reminder]: false,
  [OtherFilterType.Registered]: false,
  [OtherFilterType.SystemLog]: false,
  [OtherFilterType.ConsultantApp]: false,
  [OtherFilterType.WelcomeEmail]: false,
  [OtherFilterType.UserSettings]: false
};

export function createInitialMainFilters(
  userGroups: string[]
): Record<MainFilterType, boolean> {
  if (
    userGroups.any((group) =>
      [
        "crm-group-hba",
        "crm-group-oc-staffing",
        "crm-group-bemanningskoordinator"
      ].includes(group)
    )
  ) {
    return {
      [MainFilterType.Call]: true,
      [MainFilterType.Noanswer]: true,
      [MainFilterType.Email]: false,
      [MainFilterType.SMS]: false,
      [MainFilterType.Comment]: true,
      [MainFilterType.Interest]: false
    };
  }

  return initialMainFilters;
}
